/**
 * Stacking order for fixed overlays. Higher = closer to the user.
 * Toasts stay above modals so errors are never hidden behind a backdrop.
 * Use these values with `style={{ zIndex: Z_INDEX.toast }}` (or Tailwind `z-[300]` matching the number).
 */
export const Z_INDEX = {
  chrome: 80,
  modal: 100,
  paymentModal: 105,
  confirmModal: 110,
  /** Bottom sticky promo / CTA — below nav overlay, above ordinary modals */
  stickyCta: 130,
  navOverlay: 150,
  /** Admin quota cooldown banner — above dialogs, below session + toast */
  quotaBanner: 200,
  sessionExpiredModal: 240,
  toast: 300,
} as const;
